import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getPastOrderList } from "./PastOrderApi";
import { PastOrderDataState } from "../../../features/view/private/profilePage/components/PastOrderTypes";

const initialState: PastOrderDataState = {
  orderInfoData: {
    data: [],
    loader: false,
  },
};

export const getPastOrderListAsync = createAsyncThunk(
  "orders/past-orders/",
  async () => {
    const response = await getPastOrderList();
    return response;
  }
);

export const PastOrderSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    orderInfoData(state, action) {
      state.orderInfoData = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPastOrderListAsync.pending, (state) => {
        state.orderInfoData.loader = true;
      })
      .addCase(getPastOrderListAsync.fulfilled, (state, action: any) => {
        state.orderInfoData.loader = false;
        state.orderInfoData.data = action?.payload?.data?.orders || [];
      })
      .addCase(getPastOrderListAsync.rejected, (state) => {
        state.orderInfoData.loader = false;
      });
  },
});
export const { orderInfoData } = PastOrderSlice.actions;

export default PastOrderSlice.reducer;
